import { jsx as o } from "react/jsx-runtime";
import { Avatar as i, alpha as c } from "@mui/material";
import { _ as m, e as p, D as d } from "../../../pointsGraph-DTJju-rA.js";
import { stripHtmlAndDecode as l } from "../../../helpers/strings.js";
const v = ({ Category: t, Note: r, Title: s }) => {
  const n = l(r), { color: e, iconType: a } = m(t);
  return /* @__PURE__ */ o(
    p,
    {
      itemType: "lessonplan",
      title: s,
      description: n,
      avatar: /* @__PURE__ */ o(i, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: c(e, 0.15), color: e }, children: /* @__PURE__ */ o(d, { iconType: a }) }),
      category: t
    }
  );
};
export {
  v as LessonPlanItem
};
//# sourceMappingURL=lessonPlan.js.map
